import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { KompisPrompt, KompisText } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { actionCloseDialog } from '../../state/dialog/dialogActions';
import StopPropagation from '../utils/StopPropagation';
import { selectIsMobilePortrait } from '../../state/userAgent/userAgentSelectors';
import { selectDialogOptions } from '../../state/dialog/dialogSelectors';
import { ameliorationDialogCallbacks } from '../../services/amelioration';
import { AmeliorationDialogContent } from '../../services/amelioration/ameliorationTypes';
import localStatisticsReporter from '../../services/statistics/insights/custom/local/localStatisticsReporter';

const AmeliorationDialog = () => {
  const isMobilePortrait = useSelector(selectIsMobilePortrait);
  const dialogOptions = useSelector(selectDialogOptions);
  const dispatch = useDispatch();

  const dialogContent: AmeliorationDialogContent | null =
    dialogOptions?.options?.ameliorationData?.dialogContent || null;

  useEffect(() => {
    localStatisticsReporter.reportAmeliorationDialogShown();
  }, []);

  /**
   * Handle on decline
   */
  const declineClick = () => {
    localStatisticsReporter.reportAmeliorationDialogDeclined();
    dispatch(actionCloseDialog());
    if (ameliorationDialogCallbacks?.onDeclineClicked) {
      ameliorationDialogCallbacks.onDeclineClicked();
    } else {
      throw new Error('No decline callback found for amelioration dialog.');
    }
  };

  /**
   * Handle on accept
   */
  const acceptClick = () => {
    localStatisticsReporter.reportAmeliorationDialogAccepted();
    dispatch(actionCloseDialog());
    if (ameliorationDialogCallbacks?.onAcceptClicked) {
      ameliorationDialogCallbacks.onAcceptClicked();
    } else {
      throw new Error('No accept callback found for amelioration dialog.');
    }
  };

  const isPrimaryButtonEvent = (type: PromptButtonTypeEnum) =>
    type === PromptButtonTypeEnum.primaryButton;

  const handleButtonClick = ({ detail: { type } }: any) =>
    isPrimaryButtonEvent(type) ? acceptClick() : declineClick();

  return dialogContent ? (
    <StopPropagation>
      <div data-testid="amelioration-dialog">
        <KompisPrompt
          visible={true}
          compact={!isMobilePortrait}
          disableIframeSticky={true}
          theme={SkapaTheme}
          heading={dialogContent.headerText}
          primaryButtonLabel={dialogContent.acceptText}
          secondaryButtonLabel={dialogContent.declineText}
          onButtonClick={handleButtonClick}
        >
          <KompisText theme={SkapaTheme}>{dialogContent.bodyText}</KompisText>
        </KompisPrompt>
      </div>
    </StopPropagation>
  ) : null;
};

export default AmeliorationDialog;
